import { useContext } from "react";
import { Routes, Route, useNavigate, Navigate } from "react-router-dom";

/* ===================== AUTH ===================== */
import Login from './pages/Login/Login';

/* ===================== COMMON ===================== */
import StoreSuccess from "./pages/gateway/StoreSuccess";
import StoreFailure from "./pages/gateway/StoreFailure";
import StoreResSuccess from './pages/gateway/StoreResSuccess';
import StoreResFailure from './pages/gateway/StoreResFailure';

import CustSuccess from "./pages/gateway/CustSuccess";
import CustFailure from "./pages/gateway/CustFailure";
import CustResSuccess  from './pages/gateway/CustResSuccess';
import CustResFailure  from './pages/gateway/CustResFailure';

import Navbar     from "./pages/Header/Navbar";
import Footer     from "./pages/Footer/Footer";
import PlusNavbar from "./pages/Header/PlusNavbar";

import Dashboard        from "./pages/dashboard/Home";
import DashboardPlus    from "./pages/dashboard/HomePlus";
import LoyaltyDashboard from "./pages/dashboard/LoyaltyDashboard";

import CouponList   from "./pages/offer/CouponList";
import CreateCoupon from "./pages/offer/CreateCoupon";

import PrintPhysicalCard    from "./pages/printcard/PhysicalLoyaltyCard";
import PrintPhysicalBack    from "./pages/printcard/PhysicalLoyaltyBack";
import PhysicalLoyaltyQr    from "./pages/printcard/PhysicalLoyaltyQr";
import LuckyDrawCoupon      from "./pages/printcard/LuckyDrawCoupon";
import LuckyDrawCouponBack  from "./pages/printcard/LuckyDrawCouponBack";
import LuckyDrawRedeem      from "./pages/printcard/LuckyDrawRedeem";
import LuckyDrawCouponQr    from "./pages/printcard/LuckyDrawCouponQr";

import Wallet           from "./pages/Wallet/Wallet";
import WalletPlus       from "./pages/Wallet/WalletPlus";

import IssuedList       from "./pages/report/IssuedList";
import RedeemedList     from "./pages/report/RedeemedList";
import CustomerList     from "./pages/report/CustomerList";
import CustPhysicalCardList from "./pages/report/CustPhysicalCardList";

import { TotalPlusCustomer }     from "./pages/customer/CashiPlusCustomerList";
import CashiCustomerReport  from "./pages/report/CashiCustomerReport";
import CashiSaleReport      from "./pages/report/CashiSaleReport";

import StoreLoyaltySetting  from "./pages/store/LoyaltySetting";
import LotRedemmCustList    from "./pages/cashi_lot_qrcode/LotRedemmCustList";
import RedeemedCustHistory  from "./pages/cashi_lot_qrcode/LotQrRedeemHistory";
import CampaignList         from "./pages/campaign/CampaignList";
import CreatePromotion      from "./pages/promotion/CreatePromotion";

import DialogBox from "./components/ajax/DialogBox";

import QR from "./pages/PlusQrcode/QR";

import StoreReviewList from './pages/review/StoreReviewList';
import StoreReviewAdd  from './pages/review/StoreReviewAdd';

/* ===================== DASHBOARD PLUS ===================== */
import GeneratedQR  from "./pages/cashi_lot_qrcode/GeneratedQR";


import LoadQR from "./components/DashboardPlus/LoadQR";
import GenerateQRCode from "./components/DashboardPlus/GenerateQRCode";
import PrintQRPlus from "./components/DashboardPlus/PrintQRPlus";

import LoadnActiveQR from "./components/DashboardPlus/LoadnActiveQR";

import { ActivatedQR } from "./components/DashboardPlus/ActivatedQR";
import {LoadedQR} from "./components/DashboardPlus/LoadedQR";
import { DataContext } from "./context/DataContext";

// ================================================= 
// ================== AUTH GUARD =================== 
// ================================================= 

const RequireAuth = ({ children }) => 
{
    const { loginData } = useContext(DataContext);
    const isAuthenticated = !!loginData?.store_info?.store_id;

    return isAuthenticated ? children : <Navigate to="/" replace />;
};

// ------------------------------------------------------------------
// MAIN DASHBOARD LAYOUT
// ------------------------------------------------------------------
const DashboardLayout = ({ onLogout }) => (
  <div style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
    <Navbar onLogout={onLogout} />

    <div style={{ flex: 1 }}>
      <Routes>
        <Route index              element={<Dashboard />} />
        <Route path="home"        element={<Dashboard />} />
        <Route path="dashboard"   element={<LoyaltyDashboard />} />
        
        <Route path="customerReport"  element={<CashiCustomerReport />} />
        <Route path="saleReport"      element={<CashiSaleReport />} />
        <Route path="customerList"    element={<CustomerList />} />
        <Route path="physicalCard"    element={<CustPhysicalCardList />} />
        <Route path="issuedList"      element={<IssuedList />} />
        <Route path="redeemedList"    element={<RedeemedList />} />
      
        <Route path="printphysicalcard" element={<PrintPhysicalCard />} />
        <Route path="printphysicalback" element={<PrintPhysicalBack />} />
        <Route path="printphysicalqr"   element={<PhysicalLoyaltyQr />} />
        
        <Route path="luckydrawcoupon" element={<LuckyDrawCoupon />} />
        <Route path="luckydrawcouponback" element={<LuckyDrawCouponBack />} />
        <Route path="luckydrawcouponQr" element={<LuckyDrawCouponQr />} />
        <Route path="luckydrawredeem" element={<LuckyDrawRedeem />} />

        <Route path="couponlist"      element={<CouponList />} />
        <Route path="createcoupon"    element={<CreateCoupon />} />
        <Route path="createpromotion" element={<CreatePromotion />} />

        <Route path="wallet" element={<Wallet />} />
        
        <Route path="campaignList" element={<CampaignList />} />

        <Route path="reviewList" element={<StoreReviewList />} />

        
        <Route path="loyaltysetting" element={<StoreLoyaltySetting />} />

        <Route path="dialogbox" element={<DialogBox />} />
        <Route path="success" element={<StoreSuccess />} />
        <Route path="failure" element={<StoreFailure />} />
      </Routes>
    </div>

    <Footer />
  </div>
);

// ------------------------------------------------------------------
// DASHBOARD PLUS LAYOUT
// ------------------------------------------------------------------
const DashboardPlusLayout = ({ onLogout }) => (
  <div style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
    <PlusNavbar onLogout={onLogout} />
    
    <div style={{ flex: 1 }}>
      <Routes>
        <Route index element={<DashboardPlus />} />
        <Route path="walletPlus"  element={<WalletPlus />} />

        <Route path="generatedQR" element={<GeneratedQR />} />
        <Route path="activatedQR" element={<ActivatedQR />} />
        <Route path="loadedQR" element={<LoadedQR />} />
        <Route path="loadnactiveqr" element={<LoadnActiveQR />} />

        <Route path="totalPlusCustomer" element={<TotalPlusCustomer />} />
        <Route path="generateQR" element={<GenerateQRCode />} />
        <Route path="qr" element={<QR />} />
        <Route path="printQR" element={<PrintQRPlus />} />
        <Route path="loadQR" element={<LoadQR />} />

        
        <Route path="redeemed"    element={<LotRedemmCustList />} />
        <Route path="redeemed/redeemedcusthistory" element={<RedeemedCustHistory />} />

        <Route path="success" element={<StoreSuccess />} />
        <Route path="failure" element={<StoreFailure />} />
      </Routes>
    </div>

    <Footer />
  </div>
);

/* ================================================= */
/* ================= PUBLIC ROUTES ================= */
/* ================================================= */

const PublicRoutes = ({ onLogin }) => (
  <Routes>
    <Route path="/" element={<Login onLogin={onLogin} />} />
    <Route path="/store_pay_sucsess" element={<StoreResSuccess />} />
    <Route path="/store_pay_failure" element={<StoreResFailure />} />
    <Route path="/cust_pay_sucsess"  element={<CustResSuccess />} />
    <Route path="/cust_pay_failure"  element={<CustResFailure />} />   
    <Route path="csuccess"           element={<CustSuccess />} />
    <Route path="cfailure"           element={<CustFailure />} /> 
    <Route path="/reviewadd"         element={<StoreReviewAdd />} />
    <Route path="*" element={<Navigate to="/" replace />} />
  </Routes>
);

// ------------------------------------------------------------------
// APP ROUTES
// ------------------------------------------------------------------
const AppRoutes = () => 
{
    const navigate = useNavigate();
    const { loginData, setLoginData } = useContext(DataContext);

    const isAuthenticated = !!loginData?.store_info?.store_id;
    const cashiPlusFlag = loginData?.store_info?.cashi_plus_flag;

    /* ---------------- LOGIN ---------------- */
    const handleLogin = (userData) => 
    {
        // ✅ Update Context
        const formattedUser = { ...userData,store_info: userData.store_info};
        setLoginData(formattedUser);

        const cashiPlusFlag = userData?.store_info?.cashi_plus_flag;
    
        if (cashiPlusFlag === "2") { navigate("/dashboardPlus"); }
        else 
        {
            navigate("/home");
        }

    };

  /* ---------------- LOGOUT ---------------- */
  const handleLogout = () => 
  {
      sessionStorage.clear();
      setLoginData({});
      navigate("/", { replace: true });
  };

  if (!isAuthenticated) 
  {
    return <PublicRoutes onLogin={handleLogin} />;
  }

  return (
    <Routes>   
      
      {/* PLUS DASHBOARD */}
        <Route path="/dashboardPlus/*" element={ <RequireAuth> 
            {(cashiPlusFlag === "1" || cashiPlusFlag === "2") ? (<DashboardPlusLayout onLogout={handleLogout} /> ) : (<Navigate to="/home" replace />)} </RequireAuth>} />

      {/* NORMAL DASHBOARD */}
          <Route path="/*" element={ <RequireAuth> 
              {cashiPlusFlag === "2" ? ( <Navigate to="/dashboardPlus" replace /> ) : ( <DashboardLayout onLogout={handleLogout} /> )} </RequireAuth> }/>

    </Routes>
  );
};

export default AppRoutes;
